import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// Actions
import actions from '../../../actions/artwork';
import lexiqueActions from '../../../actions/lexique';

// Components
import Breadcrumbs from '../../tools/breadcrumbs/Breadcrumbs';
import Card from '../../cards/card/Card';
import CardGrid from '../../cards/cardGrid/CardGrid';
import ImageGallery from '../parts/imageGallery/ImageGallery';
import LinedTitle from '../../tools/linedTitle/LinedTitle';
import Loader from '../../tools/loader/Loader';
import RelatedContent from '../parts/RelatedContent';
import SingleTitle from '../parts/SingleTitle';
import Sharer from '../../tools/share/Sharer';
import Resources from '../parts/Resources';
import TableSpecs from '../../tools/wysiwyg/parts/tableSpecs/TableSpecs';
import Wysiwyg from '../../tools/wysiwyg/Wysiwyg';
import NotFound from '../../pages/NotFound';
import createInfoBulle from '../parts/InfoBulle';
import InfoBulleReference from '../parts/InfoBulleReference';
// Functions
import { getHelmetTags, getLoadingHelmetTags } from '../../tools/helmetHelpers';

// Styles
import '../styles.scss';
import './styles.scss';


class Artwork extends Component {
  constructor(props, { initialRender, customStore }) {
    const { getArtwork, getArtworkPreview, match, preview } = props;
    super(props);
    this.imageContainerRef = React.createRef();
    this.lexiconElementsRef = React.createRef();
    this.lexiconElementsRef.current = [];
    this.lexiconArtisteElementsRef = React.createRef();
    this.lexiconArtisteElementsRef.current = [];
    this.state = { imageContainerHeight: 0 };
    this.updateImageContainerHeight = this.updateImageContainerHeight.bind(this);
    if (initialRender) {
      if (preview) {
        getArtworkPreview(match.params.slug, customStore);
      } else {
        getArtwork(match.params.slug, customStore);
      }
    }
  }

  componentDidMount() {
    const {
      artwork,
      getArtwork,
      getArtworkPreview,
      match: { params: { slug } },
      preview,
    } = this.props;
    if (Object.keys(artwork).length === 0) {
      if (preview) {
        getArtworkPreview(slug);
      } else {
        getArtwork(slug);
      }
    }
    window.addEventListener('resize', this.updateImageContainerHeight);
    this.updateImageContainerHeight();
  }

  componentDidUpdate(prevProps) {
    const { match: { params: { slug: prevSlug } } } = prevProps;
    const { match: { params: { slug } }, getArtwork } = this.props;
    if (prevSlug !== slug) {
      getArtwork(slug);
      this.updateImageContainerHeight();
    }
  }
  componentWillUnmount() {
    const { reinitializeArtwork } = this.props;
    reinitializeArtwork();
    window.removeEventListener('resize', this.updateImageContainerHeight);
  }

  updateImageContainerHeight() {
    if (this.imageContainerRef.current !== null) {
      this.setState({
        imageContainerHeight: this.imageContainerRef.current.offsetHeight,
      });
    }
  }
  infoBulleRefHandler = () => {
    const { fetchLexiqueSlug } = this.props;
    InfoBulleReference(fetchLexiqueSlug, this.lexiconElementsRef.current, 'desc');
  }
  infoBulleArtisteRefHandler = () => {
    const { fetchLexiqueSlug } = this.props;
    InfoBulleReference(fetchLexiqueSlug, this.lexiconArtisteElementsRef.current, 'artiste-desc');
  }
  render() {
    const { imageContainerHeight } = this.state;
    const { t, request } = this.context;
    const { artwork, isLoading, notFound, lexiqueResultsSlug } = this.props;
    const lxLength = lexiqueResultsSlug.length;
    const lexiqueRefs = this.lexiconElementsRef.current;
    const lexiqueArtisteRefs = this.lexiconArtisteElementsRef.current;
    if (lxLength !== 0 && lexiqueArtisteRefs.length === lxLength) {
      createInfoBulle(lexiqueResultsSlug, lexiqueArtisteRefs, 'artiste-desc');
    }
    if (lxLength !== 0 && lexiqueRefs.length === lxLength) {
      createInfoBulle(lexiqueResultsSlug, lexiqueRefs, 'desc');
    }

    // 404
    if (notFound) return <NotFound />;

    const minHeightStyle = { minHeight: imageContainerHeight };
    const cardGridSettings = {
      arrows: false,
      dots: true,
      slidesToShow: 2,
      infinite: false,
      responsive: [
        {
          breakpoint: 608,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    };
    const {
      activities = [],
      artists = [],
      contentType,
      description,
      dimensions,
      expressionTechniques,
      uploads,
      otherArtworks = [],
      productionDate,
      appreciationFiles = [],
      resourcesFiles = [],
      resourcesVideos = [],
      importantLinks = [],
      suggestionsLinks = [],
      suggestionsMedias = [],
      artworkID,
      title,
      seoData,
    } = artwork;
    let shareUrl = '';
    if (request) {
      shareUrl = [request.protocol, '://', request.headers.host, request.originalUrl].join('');
    } else if (window) {
      shareUrl = window.location.href;
    }
    const shareImgUrl = seoData && seoData.image ? seoData.image.medium : '';
    const shareDescription = seoData ? seoData.description : '';
    return (
      <div>
        {isLoading ? getLoadingHelmetTags(t) : getHelmetTags(t, seoData, artists.map(artist => artist.name).join('; '))}
        {isLoading ?
          <Loader loading={isLoading} fullscreen />
          :
          <React.Fragment>
            <div className="section section--full-width">
              <article className="single">
                <div className="single__header">
                  <Breadcrumbs contentType={contentType} title={title} />
                  <div>
                    <Sharer
                      shareUrl={shareUrl}
                      shareImgUrl={shareImgUrl}
                      shareDescription={shareDescription}
                    />
                  </div>
                </div>
                <div className="single__columns" style={minHeightStyle}>
                  <SingleTitle
                    title={artists.map(artist => artist.name).join('; ')}
                    subtitle={title}
                  />
                  <div className="single__image" ref={this.imageContainerRef}>
                    <ImageGallery
                      artworkID={artworkID}
                      medias={uploads}
                      updateImageContainerHeight={this.updateImageContainerHeight}
                    />
                  </div>
                  <div className="single__details single__columns__content">
                    <Wysiwyg>
                      <TableSpecs
                        specs={[
                          { name: t('pages.artwork.productionDate'), value: productionDate },
                          { name: t('pages.artwork.expressionTechniques'), value: expressionTechniques },
                          { name: t('pages.artwork.dimensions'), value: dimensions },
                        ]}
                      />
                      <div className="single__details__text">
                        {artists
                          .filter(artist => (artist.description !== '' || (artist.bio && artist.bio !== '') || (artist.use_advanced_editor && artist.description_wysiwyg !== '')))
                          .map(artist =>
                            <React.Fragment key={artist.name}>
                              <span className="single__details__heading">
                                {t('pages.single.about', { n: artist.name })}
                              </span>
                              <p>
                                {artist.bio}
                              </p>
                              {artist.use_advanced_editor && artist.description_wysiwyg !== '' &&
                              <div
                                id="artiste-desc"
                                dangerouslySetInnerHTML={{ __html: artist.description_wysiwyg }}
                                ref={this.infoBulleArtisteRefHandler}
                              />
                              }
                              {!artist.use_advanced_editor &&
                                <p>
                                  {artist.description}
                                </p>
                              }
                            </React.Fragment>,
                        )}
                        {description !== '' &&
                          <React.Fragment>
                            <span className="single__details__heading">
                              {t('pages.single.about', { n: title })}
                            </span>
                            {/* eslint-disable-next-line react/no-danger-with-children */}
                            <div
                              id="desc"
                              dangerouslySetInnerHTML={{ __html: description }}
                              ref={this.infoBulleRefHandler}
                            />
                          </React.Fragment>
                        }

                        { importantLinks && importantLinks.length > 0 && (
                          <aside className="artwork__important-links">
                            { importantLinks.map(link => (
                              <a
                                key={link.label}
                                href={link.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="button button--border artwork__important-link"
                              >
                                {link.label}
                              </a>
                            ))}
                          </aside>
                        )}
                      </div>
                    </Wysiwyg>
                    {appreciationFiles.length > 0 &&
                    <div className="single__details__resources">
                      <CardGrid>
                        {appreciationFiles.map((appreciationFile) =>
                          <div className="grid__item" key={`resourceCard-${appreciationFile.slug}`}>
                            <Card
                              {...appreciationFile}
                              horizontal
                              withoutDetails
                            />
                          </div>,
                        )}
                      </CardGrid>
                    </div>
                    }
                  </div>
                </div>
              </article>
            </div>
            <div className="section linked-activities">
              {activities.length > 0 &&
                <div className="section__wrapper">
                  <div className="annex">
                    <LinedTitle
                      title={t('pages.artwork.linkedActivities.title')}
                      description={activities.length > 1 ? t('pages.artwork.linkedActivities.description', { n: 'œuvre' }) : t('pages.artwork.linkedActivities.descriptionSingular', { n: 'œuvre' })}
                    />
                    <div className="grid">
                      <CardGrid
                        sliderBreakpoint={767}
                        settings={cardGridSettings}
                      >
                        {activities.map((activity) =>
                          <div className="grid__item" key={`activityCard-${activity.slug}-${activity.id}`}>
                            <Card
                              {...activity}
                            />
                          </div>,
                        )}
                      </CardGrid>
                    </div>
                  </div>
                </div>
              }
              <Resources
                contentType="artwork"
                resourcesFiles={resourcesFiles}
                resourcesVideos={resourcesVideos}
                suggestionsLinks={suggestionsLinks}
                suggestionsMedias={suggestionsMedias}
              />
            </div>
            {otherArtworks.length > 0 &&
              <RelatedContent
                title={t('pages.artwork.otherArtworks.title')}
              >
                {otherArtworks.map((card) =>
                  <div className="grid__item" key={`artworkCard-${card.slug}-${card.id}`}>
                    <Card
                      {...card}
                    />
                  </div>,
                )}
              </RelatedContent>
            }
          </React.Fragment>
        }
      </div>
    );
  }
}

Artwork.propTypes = {
  artwork: PropTypes.object.isRequired,
  getArtwork: PropTypes.func.isRequired,
  getArtworkPreview: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  preview: PropTypes.bool,
  reinitializeArtwork: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  notFound: PropTypes.bool.isRequired,
  fetchLexiqueSlug: PropTypes.func.isRequired,
  lexiqueResultsSlug: PropTypes.array.isRequired,
};

Artwork.defaultProps = {
  preview: false,
};

Artwork.contextTypes = {
  customStore: PropTypes.object,
  initialRender: PropTypes.bool,
  t: PropTypes.func,
  request: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    artwork: state.artwork.postData,
    isLoading: state.artwork.isLoading,
    notFound: state.artwork.notFound,
    lexiqueResultsSlug: state.lexique.lexiqueResultsSlug,
  };
}

export default withRouter(connect(mapStateToProps, { ...actions, ...lexiqueActions })(Artwork));



// WEBPACK FOOTER //
// ./src/app/components/singles/artwork/Artwork.js